/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderMarketPositioningMapView', 'model/StakeholderMarketPositioningMapViewReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderMarketPositioningMapView'), require('../model/StakeholderMarketPositioningMapViewReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderMarketPositioningMapViewApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderMarketPositioningMapView, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewReport);
  }
}(this, function(ApiClient, StakeholderMarketPositioningMapView, StakeholderMarketPositioningMapViewReport) {
  'use strict';

  /**
   * StakeholderMarketPositioningMapView service.
   * @module api/StakeholderMarketPositioningMapViewApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderMarketPositioningMapViewApi. 
   * @alias module:api/StakeholderMarketPositioningMapViewApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewAddFromTemplateGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewAddFromTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} templateID 
     * @param {Integer} groupID 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewAddFromTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderMarketPositioningMapViewAddFromTemplateGet = function(_4SAPIAppID, templateID, groupID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewAddFromTemplateGet";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling stakeholderMarketPositioningMapViewAddFromTemplateGet";
      }

      // verify the required parameter 'groupID' is set
      if (groupID == undefined || groupID == null) {
        throw "Missing the required parameter 'groupID' when calling stakeholderMarketPositioningMapViewAddFromTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'groupID': groupID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/addFromTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewAddPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapView} body 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderMarketPositioningMapViewAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewDeleteGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} viewID 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewDeleteGet = function(_4SAPIAppID, viewID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewDeleteGet";
      }

      // verify the required parameter 'viewID' is set
      if (viewID == undefined || viewID == null) {
        throw "Missing the required parameter 'viewID' when calling stakeholderMarketPositioningMapViewDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'viewID': viewID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewEditPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapView} body 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewInvitePut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewInvitePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * invite
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} viewID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.message  (default to )
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewInvitePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewInvitePut = function(_4SAPIAppID, body, viewID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewInvitePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewInvitePut";
      }

      // verify the required parameter 'viewID' is set
      if (viewID == undefined || viewID == null) {
        throw "Missing the required parameter 'viewID' when calling stakeholderMarketPositioningMapViewInvitePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'viewID': viewID,
        'message': opts['message']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/invite', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewLoadAllGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderMarketPositioningMapViewReport>}
     */
    this.stakeholderMarketPositioningMapViewLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderMarketPositioningMapViewReport];

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewLoadGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderMarketPositioningMapViewReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} viewID 
     * @param {module:api/StakeholderMarketPositioningMapViewApi~stakeholderMarketPositioningMapViewLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderMarketPositioningMapViewReport}
     */
    this.stakeholderMarketPositioningMapViewLoadGet = function(_4SAPIAppID, viewID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewLoadGet";
      }

      // verify the required parameter 'viewID' is set
      if (viewID == undefined || viewID == null) {
        throw "Missing the required parameter 'viewID' when calling stakeholderMarketPositioningMapViewLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'viewID': viewID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderMarketPositioningMapViewReport;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapView/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
